import { ActionReducerMap } from "@ngrx/store";
import { AppStateInterface, IEmpleador, IEntidad } from "@shared/interfaces/app.state.interfaces";
import { debidaDiligenciaReducer } from "./reducers/debida-diligencia.reducers";
import { empleadorReducer } from "./reducers/empleador.reducers";
import { entidadesReducer } from "./reducers/entidades.reducers";
import { entidadesSinCredencialesReducer } from "./reducers/entidades-sin-credenciales.reducers";
import { httpErrorInterceptorReducer } from "./reducers/error.reducers";
import { loadingReducer } from "./reducers/loading.reducers";
import { seguridadReducer } from "./reducers/seguridad.reducers";
import { serviciosExternosReducer } from "./reducers/servicios-externos.reducers";
import { terminosCondicionesReducer } from "./reducers/terminos-condiciones.reducers";
import { pagosReducer } from "./reducers/pagos.reducers";
import { updateOnboardingDataReducer } from "./reducers/updateOnboardingData.reducers";
import { parametrizacionFocunReducer, ParametrizacionFocunState } from "./reducers/parametrizacion-focun.reducers";

export interface AppState {
    loading: AppStateInterface
    seguridad: any
    serviciosExternos: any
    debidaDiligencia: any
    empleador: IEmpleador
    terminosCondiciones: any
    httpErrorInterceptor: any,
    pagos: any,
    updateOnboardingDataReducer: any,
    entidadesSinCredenciales: any
    entidades: { [tipo: string]: IEntidad[] }
    parametrizacionFocun: ParametrizacionFocunState 
}

export const ROOT_REDUCERS: ActionReducerMap<AppState> = {
    loading: loadingReducer,
    seguridad: seguridadReducer,
    serviciosExternos: serviciosExternosReducer,
    debidaDiligencia: debidaDiligenciaReducer,
    terminosCondiciones: terminosCondicionesReducer,
    httpErrorInterceptor: httpErrorInterceptorReducer,
    empleador: empleadorReducer,
    pagos: pagosReducer,
    updateOnboardingDataReducer: updateOnboardingDataReducer,
    entidadesSinCredenciales: entidadesSinCredencialesReducer,
    entidades: entidadesReducer,
    parametrizacionFocun: parametrizacionFocunReducer
}